import styled from 'styled-components';
import { Flex } from '@catalogo/theme-layout';
import { Text } from '@catalogo/theme-text';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 16px 0;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  z-index: 20;
`;

export const ButtonsWrapper = styled(Flex)`
  place-content: center;
  margin: 8px ${({ $hasSecondaryButton }) => ($hasSecondaryButton ? '8px' : '16px')} 0px;
  gap: 0px 8px;
`;

export const CashbackText = styled(Text)`
  font-size: 12px;
  ${({ $isSecondLine }) => $isSecondLine && 'margin-top: 8px;'}
`;

export const PriceWrapper = styled.div`
  margin: 0px 24px;
`;
